import { useEffect, useState } from 'react'
import { Flex, Spin, Typography } from 'antd'
import dayjs from 'dayjs'
import { Trans, useTranslation } from 'react-i18next'
import { BackButton } from '../../elements'
import api from '../../api'
import OrderDetail, { cardBorderColor, getDisplayStatus, statusTitleKeys } from './OrderDetail'

const { Title, Text } = Typography

const formatDate = (dateStr) => dayjs(dateStr).format('MMM D YYYY')

const Orders = () => {
  const [orders, setOrders] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    api.get('/api/v2/corporate/tote_orders')
      .then(({ data }) => setOrders(data))
      .finally(() => setIsLoading(false))
  }, [])

  if (selectedOrder) {
    return (
      <OrderDetail
        onBack={() => setSelectedOrder(null)}
        order={selectedOrder}
      />
    )
  }

  return (
    <Spin description={t('loading')} size="large" spinning={isLoading}>
      <div className="order-history-wrapper">
        <Title className="align-item-center" level={2}>
          <Trans>ordersTitle</Trans>
        </Title>

        {!isLoading && orders?.length === 0 ? (
          <p className="align-item-center"><Trans>noOrders</Trans></p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {orders?.map((order) => {
              const status = getDisplayStatus(order)
              const date = order.cancelled_at || order.delivered_at || order.with_carrier_at || order.ready_to_ship_at || order.prepared_at || order.in_progress_at || order.created_at
              const titleColor = cardBorderColor(order)
              const titleKey = statusTitleKeys[status]

              return (
                <Flex
                  align="start"
                  flexDirection="column"
                  key={order.id}
                  onClick={() => setSelectedOrder(order)}
                  onKeyDown={(e) => e.key === 'Enter' && setSelectedOrder(order)}
                  role="button"
                  style={{
                    background: '#fff',
                    border: '1px solid #f0f0f0',
                    borderRadius: 40,
                    cursor: 'pointer',
                    padding: '12px 16px',
                  }}
                  tabIndex={0}
                  vertical
                >
                  <Text strong style={{ color: titleColor }}>
                    {t(titleKey, { quantity: order.tote_quantity })}
                  </Text>
                  <Text style={{ color: '#8c8c8c', fontSize: 13 }}>
                    {formatDate(date)}
                  </Text>
                </Flex>
              )
            })}
          </div>
        )}

        <div className="btn-wrapper">
          <BackButton />
        </div>
      </div>
    </Spin>
  )
}

export default Orders
